import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";

interface Step1Props {
  isDeveloper: string;
  onUpdateState: (value: string) => void;
}

const Step1Developer: React.FC<Step1Props> = ({
  isDeveloper,
  onUpdateState,
}) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">Are you the developer for this app?</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
              ]}
              value={isDeveloper}
              onChange={onUpdateState}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step1Developer;
